const RouteAssigment = {

    // FIELDS
    "customer": "العميل",
    "route": "المسار",
    "search": "بحث",

    // PAGE HEADER
    "customer_route_assignment": "تعيين مسار العميل",

    // ERROR
    "error_customer": "يرجى اختيار العميل",
    "error_route": "يرجى اختيار المسار",

    // TABLE HEADER
    "table_customer": 'العميل',
    "table_route": "المسار",

}

export default RouteAssigment;